<template>
  <div>
    <v-card class="mx-auto top20" max-width="auto">
      <v-card-text>
        <p :class="rowClass" class="product-title text--primary">
          <b>{{ good.article }}</b> {{ good.name }}
        </p>
        <p :class="rowClass">
          Стоимость:
          <b>{{ price }} <span class="currency-rub"></span></b> Кол-во:
          <b>{{ good.quantity }} </b>
        </p>

        <template v-if="good.quantity > 0 && good.draftUkdList.length < 2">
          <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  block
                  v-bind="attrs"
                  v-on="on"
                  @click="setDraftUkdInitialQuantity"
                >
                  Коррекция
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">{{ good.article }}</span>
                </v-card-title>
                <v-card-text>
                  <div>{{ good.name }}</div>
                </v-card-text>

                <v-card-actions v-if="!openCamera">
                  <div class="center">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      color="error"
                      @click="onMinusItem"
                      :disabled="disableMinusButton"
                    >
                      <v-icon dark> mdi-minus</v-icon>
                    </v-btn>
                    <span class="text-h5 pl-3 pr-3">{{ baseQuantity }}</span>
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      color="success"
                      @click="onPlusItem"
                      :disabled="disableQuantityPlusButton"
                    >
                      <v-icon dark> mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </v-card-actions>

                <v-card-actions v-if="!openCamera">
                  <div class="center">
                    <v-radio-group
                      v-model="draftUkd.reason"
                      class="text-right"
                      row
                    >
                      <v-radio
                        v-for="reasonItem in draftUkd.availableReasons"
                        :label="reasonItem.label"
                        :value="reasonItem.value"
                        :key="reasonItem.value"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-card-actions>

                <v-card-actions class="justify-center" v-if="!openCamera">
                  <div class="ma-3" v-if="draftUkd.photo === null">
                    <v-btn @click="onTakePhoto" fab x-large dark>
                      <v-icon dark>mdi-camera-outline</v-icon>
                    </v-btn>
                  </div>
                  <v-avatar v-else class="ma-3" size="110" tile>
                    <v-img :src="draftUkd.photo"></v-img>
                  </v-avatar>
                </v-card-actions>

                <take-photo
                  v-if="openCamera"
                  :draftUkdUuid="draftUkd.uuid"
                  @openCamera="setOpenCamera"
                  @draftImage="setDraftImage"
                />

                <v-card-actions v-if="!openCamera" class="text-right">
                  <v-btn text @click="onDeleteRejectButton">Отмена</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    @click="onDeleteSaveButton"
                    :disabled="disableSaveButton"
                    >Сохранить</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-card-text>

      <v-card-actions v-if="good.quantity !== good.initial_amount">
        <v-btn block @click="show = !show">
          Корректировки
          <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-card-actions>

      <v-expand-transition>
        <div v-show="show">
          <v-divider></v-divider>
          <v-card
            class="mx-auto top20"
            max-width="auto"
            v-for="(returnGood, index) in good.draftUkdList"
            :key="index"
          >
            <v-list-item class="grow">
              <v-row align="center" justify="end">
                <v-card-text>
                  {{ getReasonName(returnGood.reason) }}
                  ({{ returnGood.quantity }} шт.)
                </v-card-text>
              </v-row>

              <v-img
                v-if="returnGood.photo !== null"
                max-height="75"
                max-width="75"
                :src="returnGood.photo"
              ></v-img>

              <v-card-actions>
                <v-btn
                  @click="onRestoreItem(returnGood)"
                  class="mx-2"
                  fab
                  small
                  color="red"
                >
                  <v-icon>
                    {{ icons.mdiDelete }}
                  </v-icon>
                </v-btn>
              </v-card-actions>
            </v-list-item>
          </v-card>
        </div>
      </v-expand-transition>
    </v-card>
    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  </div>
</template>

<script>
import ConfirmDialogue from "@/components/ConfirmDialogue.vue";
import TakePhoto from "@/components/TakePhoto";
import { mdiDelete } from "@mdi/js";
import { v4 as uuidv4 } from "uuid";

export default {
  name: "ProductList",
  components: { ConfirmDialogue, TakePhoto },
  props: ["good", "paymentIsAvailable", "updSum", "deletionProhibited", "upd"],
  data: () => ({
    icons: { mdiDelete },
    openCamera: false,
    dialog: false,
    takePhoto: false,
    deletedGoodExtId: null,
    show: true,
    reason: null,
    baseQuantity: null,
    draftUkd: {
      reason: null,
      availableReasons: [
        { label: "Отказ", value: "14" },
        { label: "Недостача", value: "25" },
      ],
      quantity: null,
      photo: null,
      uuid: null,
    },
  }),
  computed: {
    currentUkdImageLink() {
      return this.$store.getters.getCurrentUkdImageLink;
    },
    draftUkdItemQuantity() {
      let quantity = 0;
      for (let item of this.good.draftUkdList) {
        quantity = quantity + item.quantity;
      }
      return quantity;
    },
    rowClass() {
      return {
        "text-decoration-line-through": this.good.quantity === 0,
      };
    },
    quantity() {
      return this.good.quantity;
    },
    price() {
      return this.good.price;
    },
    disableMinusButton() {
      if (this.baseQuantity / this.good.packing_ration <= 1) {
        return true;
      }
      return (
        this.baseQuantity <= 1 ||
        (this.paymentIsAvailable &&
          this.updSum - this.good.one_item_price * this.good.packing_ration < 0)
      );
    },
    disableQuantityPlusButton() {
      let draftUkdItemQuantity = 0;
      for (let item of this.good.draftUkdList) {
        draftUkdItemQuantity = draftUkdItemQuantity + item.quantity;
      }
      return (
        draftUkdItemQuantity + this.draftUkd.quantity ===
        this.good.initial_amount
      );
    },
    disableSaveButton() {
      return this.draftUkd.reason === null || this.draftUkd.quantity === 0;
    },
  },
  methods: {
    setDraftUkdInitialQuantity() {
      this.draftUkd.quantity =
        this.good.initial_amount - this.draftUkdItemQuantity;
      this.baseQuantity = this.draftUkd.quantity;
      this.draftUkd.uuid = uuidv4();
      this.draftUkd.photo = null;
    },
    getReasonName(reason) {
      return Number.parseInt(reason) === 14 ? "Отказ" : "Недостача";
    },
    setOpenCamera(openCamera) {
      this.openCamera = openCamera;
    },
    setDraftImage(draftImage) {
      this.draftUkd.photo = draftImage;
    },
    onTakePhoto() {
      this.takePhoto = false;
      this.openCamera = true;
    },
    setDeletedGoodExtId(deletedGoodExtId) {
      this.deletedGoodExtId = deletedGoodExtId;
    },
    onDeleteSaveButton() {
      this.good.draftUkdList.push(this.draftUkd);
      this.$store.commit("deleteGood", {
        goodId: this.good.id,
        quantity: this.draftUkd.quantity,
      });
      let images = [];
      if (null !== this.currentUkdImageLink) {
        images.push(this.currentUkdImageLink);
      }
      const draftUkd = {
        upd: this.upd,
        linkMaster: this.good.link_master,
        goodId: this.good.id,
        goodExtId: this.good.ext_id,
        quantity: this.draftUkd.quantity,
        reason: Number.parseInt(this.draftUkd.reason),
        draftUkdUuid: this.draftUkd.uuid,
        images: images,
      };
      this.$store.commit("removeCurrentUkdImageLink");
      this.$store.commit("setCanceledGood", draftUkd);
      this.$store.commit(
        "updateSum",
        this.$store.getters.updSum -
          this.good.one_item_price * this.draftUkd.quantity
      );

      this.dialog = false;
      this.setDraftUkdData();
    },
    setDraftUkdData() {
      this.draftUkd = {
        availableReasons: this.getAvailableReasonList(),
        reason: null,
        quantity: null,
        photo: null,
        uuid: null,
        linkMaster: null,
      };
    },
    getAvailableReasonList() {
      let availableReasons = [
        { label: "Отказ", value: "14" },
        { label: "Недостача", value: "25" },
      ];

      for (let i in availableReasons) {
        this.good.draftUkdList.forEach((item) => {
          if (availableReasons[i].value === item.reason) {
            availableReasons.splice(i, 1);
          }
        });
      }

      return availableReasons;
    },
    onDeleteRejectButton() {
      this.dialog = false;
      this.setDraftUkdData();
    },
    onRestoreItem(returnGood) {
      for (let i = 0; i < this.good.draftUkdList.length; i++) {
        if (this.good.draftUkdList[i].uuid === returnGood.uuid) {
          this.good.draftUkdList.splice(i, 1);
        }
      }
      this.$store.commit("restoreGood", {
        good_id: this.good.id,
        quantity: returnGood.quantity,
      });
      this.$store.commit("removeCanceledGood", {
        draftUkdUuid: returnGood.uuid,
      });
      this.$store.commit(
        "updateSum",
        this.$store.getters.updSum +
          this.good.one_item_price * returnGood.quantity
      );
      this.setDraftUkdData();
    },
    onMinusItem() {
      this.draftUkd.quantity =
        this.draftUkd.quantity - this.good.packing_ration;
      this.baseQuantity = this.baseQuantity - this.good.packing_ration;
    },
    onPlusItem() {
      this.draftUkd.quantity =
        this.draftUkd.quantity + this.good.packing_ration;
      this.baseQuantity = this.baseQuantity + this.good.packing_ration;
    },
  },
};
</script>
